export default "__VITE_ASSET__CzuzoSt0__"